/**
 * ZERO WIDTH SPACE
 *
 * Symbol to align to baseline
 *
 * @see https://www.fileformat.info/info/unicode/char/200b/index.htm
 */
export var ZERO_WIDTH_SPACE_CSS = '\\200B';